import { render, staticRenderFns } from "./pluck401.vue?vue&type=template&id=53acd82c&scoped=true"
import script from "./pluck401.vue?vue&type=script&lang=js"
export * from "./pluck401.vue?vue&type=script&lang=js"
import style0 from "./pluck401.vue?vue&type=style&index=0&id=53acd82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53acd82c",
  null
  
)

export default component.exports